const props = [
  // { prop: 'goodsType', name: '货物类型' },
  { prop: 'goodsCategoryId', name: '货物类型id' },
  { prop: 'count', name: '货物重量' },
  { prop: 'addressFrom', name: '货物提货详细地址' },
  { prop: 'addressTo', name: '货物送达详细地址' },

];

export default class Goods {
  constructor() {
    props.forEach(item => {
      this[item.prop] = "";
    });
  }

  reset() {
    props.forEach(item => {
      this[item.prop] = "";
    });
  }

  validate() {
    const invalid = props.filter(item => this[item.prop] == '');
    return invalid;
  }
}


// WEBPACK FOOTER //
// ./src/models/Goods.js